export const instanceQueryKeys = {
  all: ['instance'],
  details: () => [...instanceQueryKeys.all, 'detail'],
  detail: (id: string) => [...instanceQueryKeys.details(), id],
  pagination: (page: number, filters: Record<string, any> = {}) => {
    // Create a consistent, serializable representation of filters
    const filterKey = Object.entries(filters)
      .filter(([, value]) => value !== undefined && value !== '')
      .map(([key, value]) => `${key}:${value}`)
      .sort()
      .join('|');

    return [
      ...instanceQueryKeys.all,
      'pagination',
      page.toString(),
      filterKey,
    ];
  },
  infinite: () => [...instanceQueryKeys.all, 'infinite'],
};

